import {OptionalOptionEntry} from '../../../reference/model';

export function mapPlaceOfRegistrationToRequest(placeOfRegistration: OptionalOptionEntry | undefined) {
    return placeOfRegistration?.value ? placeOfRegistration : undefined;
}
